<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h3>Obrigado pelo teu registo</h3>
            <p>Em breve entraremos em contacto contigo para te explicar como podes começar esta aventura connosco.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
.form-success {

    h3 {
        font-size: 24px;
        color: $dark-blue;
    }

    p {
        display: block;
        color: $dark-blue;
        width: 80%;
        margin: 0 auto;
    }
}

</style>
